// src/features/sso-auth/components/ProtectedRoute.tsx
import React from 'react';
import { useAuthStore } from '../store/authStore';
import Loading from './Loading';
import logoAbInbev from '../../../assets/images/logo_abinbev.png';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // const { isAuthenticated, isLoading, sessionChecked } = useAuthStore(
  //   (state) => ({
  //     isAuthenticated: state.isAuthenticated,
  //     isLoading: state.isLoading,
  //     sessionChecked: state.sessionChecked,
  //   })
  // );

  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const isLoading = useAuthStore(state => state.isLoading);
  const sessionChecked = useAuthStore(state => state.sessionChecked);
  console.log(sessionChecked);
  console.log(isLoading);
  if (!sessionChecked || isLoading) {
    if (typeof window !== 'undefined' && !localStorage.getItem('access_token')) {
      window.location.href = '/login';
      return null;
    }
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Verificando sesión...
          </h2>
          <p className="text-gray-600">
            Por favor espera mientras verificamos tu autenticación.
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Session is checked and user is not authenticated, redirect to login
    window.location.href = '/login';
    return       <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#222222] to-[#868686] py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-sm w-full space-y-8 bg-white p-8 rounded-3xl shadow-lg">
      <img src={logoAbInbev} className="w-28 mb-4" alt="Logo Ab Inbev" />
      <Loading message="Esto solo va tomar un momento, estamos validados tus datos." />
    </div>
  </div>
  }

  // Authenticated, session checked, and not loading
  return <>{children}</>;
};

export default ProtectedRoute;